import * as Bixby from '$/core';
import { LoginClearPreloadedData } from '../login/types';

export interface UserState {
  isLoading: boolean;
  error?: Bixby.Models.BixbyError;
  users: Bixby.Models.UserSlim[];
  currentUser?: Bixby.Models.User;
  isCreating?: boolean;
  createError?: Bixby.Models.BixbyError;
}

export const USERS_LOADING = 'USERS_LOADING';
export const USERS_FAILURE = 'USERS_FAILURE';
export const USERS_SUCCESS = 'USERS_SUCCESS';
export const UPDATE_USER = 'UPDATE_USER';
export const USER_LOADING = 'USER_LOADING';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_FAILURE = 'USER_FAILURE';
export const USER_DELETE = 'USER_DELETE';
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS';
export const USER_DELETE_FAILURE = 'USER_DELETE_FAILURE';
export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS_ACTION';
export const USER_UPDATE_FAILURE = 'USER_UPDATE_FAILURE_ACTION';

interface UsersLoading extends Bixby.Models.BixbyAction<undefined, typeof USERS_LOADING> {
  type: typeof USERS_LOADING;
}

interface UsersSuccess extends Bixby.Models.BixbyAction<Bixby.Models.UserSlim[], typeof USERS_SUCCESS> {
  type: typeof USERS_SUCCESS;
  payload: Bixby.Models.UserSlim[];
}

interface UsersFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof USERS_FAILURE> {
  type: typeof USERS_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface UserLoading extends Bixby.Models.BixbyAction<undefined, typeof USER_LOADING> {
  type: typeof USER_LOADING;
  payload: undefined;
}

interface UserSuccess extends Bixby.Models.BixbyAction<Bixby.Models.User, typeof USER_SUCCESS> {
  type: typeof USER_SUCCESS;
  payload?: Bixby.Models.User;
}

interface UserFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof USER_FAILURE> {
  type: typeof USER_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface UpdateUser extends Bixby.Models.BixbyAction<UserUpdateType, typeof UPDATE_USER> {
  type: typeof UPDATE_USER;
  payload: UserUpdateType;
}

interface CreateUser extends Bixby.Models.BixbyAction<Bixby.Models.CreateUserRequest, typeof CREATE_USER> {
  type: typeof CREATE_USER;
  payload: Bixby.Models.CreateUserRequest;
}

interface CreateUserSuccess extends Bixby.Models.BixbyAction<Bixby.Models.User, typeof CREATE_USER_SUCCESS> {
  type: typeof CREATE_USER_SUCCESS;
  payload: Bixby.Models.User;
}

interface CreateUserFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof CREATE_USER_FAILURE> {
  type: typeof CREATE_USER_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface UpdateUserSuccessAction extends Bixby.Models.BixbyAction<Bixby.Models.User, typeof USER_UPDATE_SUCCESS> {
  type: typeof USER_UPDATE_SUCCESS;
  payload: Bixby.Models.User;
}

interface UpdateUserFailureAction
  extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof USER_UPDATE_FAILURE> {
  type: typeof USER_UPDATE_FAILURE;
  payload: Bixby.Models.BixbyError;
}

export type UserUpdateType = Pick<Partial<Bixby.Models.User>, Exclude<keyof Bixby.Models.User, 'id'>> &
  Pick<Bixby.Models.User, 'id'>;

export type UserActionTypes =
  | UsersLoading
  | UsersSuccess
  | UsersFailure
  | UserLoading
  | UserSuccess
  | UserFailure
  | UpdateUser
  | CreateUser
  | CreateUserSuccess
  | CreateUserFailure
  | UpdateUserSuccessAction
  | UpdateUserFailureAction
  | LoginClearPreloadedData;
